module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Hapus Piutang (Administrator) ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Transaksi")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchShow),
      expression: "isSearchShow"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingGetReceivable,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.getReceivableData
    }
  }, [(!_vm.loadingGetReceivable) ? _c('span', [_vm._v("Cari")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGetReceivable),
      expression: "loadingGetReceivable"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receivables.length > 0),
      expression: "receivables.length > 0"
    }]
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.receivables
    },
    on: {
      "on-row-click": _vm.showDeleteReceivable
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmMarkingheadercode = ''
      }
    },
    model: {
      value: (_vm.modalConfirmDelete),
      callback: function($$v) {
        _vm.modalConfirmDelete = $$v
      },
      expression: "modalConfirmDelete"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.receivableToDelete.markingheadercode) + " : " + _vm._s(_vm.receivableToDelete.transactionDate))]), _vm._v(" "), _c('p', [_vm._v("Keterangan : "), _c('br'), _vm._v(_vm._s(_vm.receivableToDelete.description))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Debit Amount     : Rp "), _c('b', [_vm._v(_vm._s(_vm.receivableToDelete.debitAmount) + " ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.receivableToDelete.markingheadercode))]), _vm._v(" untuk Lanjut")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmMarkingheadercode),
      callback: function($$v) {
        _vm.confirmMarkingheadercode = $$v
      },
      expression: "confirmMarkingheadercode"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receivableToDelete.markingheadercode == _vm.confirmMarkingheadercode.toUpperCase()),
      expression: "receivableToDelete.markingheadercode == confirmMarkingheadercode.toUpperCase()"
    }],
    attrs: {
      "type": "error",
      "size": "large",
      "long": "",
      "loading": _vm.loadingConfirmDelete
    },
    on: {
      "click": _vm.deleteReceivable
    }
  }, [_vm._v("Hapus")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba5ffef4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/receivable/AdministratorReceivableDelete.vue
// module id = 1847
// module chunks = 1